import CSVPreviewSection from '../CSVPreviewSection'
import {BillingSummaryReportInfo} from 'constants'
import BillingSummaryCSVPreviewUtils from './BillingSummaryCSVPreviewUtils'

export default function BillingSummaryCSVPreviewHeader(){}
BillingSummaryCSVPreviewHeader.prototype = new CSVPreviewSection();
BillingSummaryCSVPreviewHeader.prototype.init = function( firstGroupingLevel, secondGroupingLevel, thirdGroupingLevel, reportInfo, columnsStrategy, numOfGroupingCols){
    CSVPreviewSection.prototype.init.call( this );
    this.firstGroupingLevel = firstGroupingLevel;
    this.secondGroupingLevel = secondGroupingLevel;
    this.thirdGroupingLevel = thirdGroupingLevel;
    this.reportInfo = reportInfo;
    this.columnsStrategy = columnsStrategy;
    this.numOfGroupingCols = numOfGroupingCols;
    return this;
};

BillingSummaryCSVPreviewHeader.prototype.hasGroupingRow = function()
{
    return this.reportInfo == BillingSummaryReportInfo.BILLABLE_TIME_AND_BILLABLE_AMOUNT
           || this.reportInfo == BillingSummaryReportInfo.BILLABLE_TIME_AND_BILLABLE_AMOUNT_WITH_AVERAGE_RATES;
};

BillingSummaryCSVPreviewHeader.prototype.addRows = function( tBody )
{
    if( this.hasGroupingRow() )
    {
        var groupingHeaderRow = this.createRow( "reportHeaderRow" );
        ReportPreviewUtils.addEmptyCells( groupingHeaderRow, this.numOfGroupingCols );
        this.columnsStrategy.addColumnGropingHeaderRowCells( groupingHeaderRow );
        this.addRow( tBody, groupingHeaderRow );
    }

    var mainHeaderRow = this.createRow( "reportHeaderRow" );
    BillingSummaryCSVPreviewUtils.addGroupingLevelsCells( mainHeaderRow, this.firstGroupingLevel, this.secondGroupingLevel, this.thirdGroupingLevel, false );

    this.columnsStrategy.addMainHeaderRowCells( mainHeaderRow );
    this.addRow( tBody, mainHeaderRow );
};


// WEBPACK FOOTER //
// ./web/js/reports/preview/csv/billingsummary/BillingSummaryCSVPreviewHeader.js